var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.566 5.07306C24.7247 6.9988 25.7266 11.134 23.8022 14.2905C21.8772 17.4482 17.7424 18.4519 14.5836 16.5261C11.4271 14.6017 10.4252 10.4665 12.3503 7.30888C14.2747 4.15236 18.4094 3.14869 21.566 5.07306ZM13.785 16.8814L7.372 27.4006C7.26456 27.5768 7.32021 27.8063 7.49757 27.9144C7.67268 28.0212 7.90215 27.9655 8.00959 27.7893L14.4157 17.2814C17.8939 19.2463 22.3421 18.115 24.4376 14.6779C26.5761 11.17 25.463 6.57584 21.954 4.43659C18.4461 2.29802 13.8513 3.4123 11.7127 6.92017C9.66104 10.2855 10.6099 14.644 13.785 16.8814Z",
    fill: "#ADB84E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0563 16.2599C16.2314 16.3667 16.4609 16.311 16.5676 16.1359C16.6751 15.9597 16.6194 15.7302 16.4443 15.6235C14.5472 14.4669 13.5858 12.786 13.5891 10.6262C13.5887 8.98008 14.1733 7.65506 14.179 7.64315C14.2633 7.45435 14.1808 7.23619 13.9926 7.15076C13.8038 7.06645 13.5832 7.15057 13.5002 7.33713C13.473 7.39443 10.9567 13.151 16.0563 16.2599Z",
    fill: "#ADB84E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7761,
    height: 28.9229,
    fill: "white",
    transform: "translate(15.0555) rotate(31.3685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.1a5314b2db06c3602115c2da8eec528c.svg";
export { ForwardRef as ReactComponent };